export const formatBytes = (b) => {
    const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let l = 0;
    let n = b;

    while (n >= 1024) {
        n /= 1024;
        l += 1;
    }

    return `${n.toFixed(n >= 10 || l < 1 ? 0 : 1)}${units[l]}`;
};

export const formatDuration = (seconds) => {
    const date = new Date(0);
    date.setSeconds(seconds);
    const dateString = date.toISOString().slice(11, 19);
    if (seconds < 3600) return dateString.slice(3);
    return dateString;
};

export const rgbToHex = (e) => {
    var t = /rgb\( *([0-9]+), *([0-9]+), *([0-9]+) *\)/g.exec(e);
    return (
        '#' +
        (
            (1 << 24) +
            (parseInt(t[1]) << 16) +
            (parseInt(t[2]) << 8) +
            parseInt(t[3])
        )
            .toString(16)
            .slice(1)
    );
};

export const removeMilliseconds = (luxonDateTime) =>
    luxonDateTime.startOf('second');
